import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { publicApi } from '../api';
import { Trophy, Medal, Award, Gamepad2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const Leaderboard = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.getLeaderboard().then((r) => { setRows(r); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const top3 = rows.slice(0, 3);
  const rest = rows.slice(3);

  return (
    <div className="bg-[#FFF4E6] min-h-screen">
      <Navbar />
      <section className="px-5 md:px-8 pt-32 pb-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Crunch Contest</div>
          <h1 className="font-display text-6xl md:text-8xl uppercase leading-[0.9] mt-2">Leaderboard</h1>
          <p className="font-brico text-lg mt-4 max-w-md opacity-70">Top 5 players win a real TruCrunch hamper worth ₹999. India only. One entry per email — best score counts.</p>

          {loading ? (
            <div className="mt-8 text-center font-brico opacity-70">Loading…</div>
          ) : rows.length === 0 ? (
            <div className="mt-10 bg-white rounded-3xl crunch-shadow p-10 text-center">
              <Trophy size={40} className="mx-auto text-[#E63946]" />
              <div className="font-display text-3xl md:text-4xl uppercase mt-4">Be the first to crunch!</div>
              <p className="font-brico opacity-70 mt-2">No entries yet. Play Sky Catch and grab the #1 spot.</p>
              <Link to="/play" className="btn-chunky primary mt-6 inline-flex"><Gamepad2 size={16} /> Play Now</Link>
            </div>
          ) : (
            <>
              <div className="mt-8 grid md:grid-cols-3 gap-4">
                {top3.map((p, i) => {
                  const colors = ['#FFD84D', '#E5E5E5', '#F4A261'];
                  const icons = [Trophy, Medal, Award];
                  const Icon = icons[i];
                  return (
                    <div key={`${p.email || p.name}-${p.rank}`} className="rounded-3xl crunch-shadow p-6 text-center" style={{ background: colors[i] }}>
                      <Icon size={32} className="mx-auto" />
                      <div className="font-display text-4xl mt-2">#{p.rank}</div>
                      <div className="font-brico font-bold text-lg mt-1">{p.name}</div>
                      <div className="text-xs uppercase opacity-70">{p.city}</div>
                      <div className="mt-3 font-display text-3xl">{p.score.toLocaleString()}</div>
                    </div>
                  );
                })}
              </div>

              {rest.length > 0 && (
                <div className="mt-8 bg-white rounded-3xl crunch-shadow overflow-hidden">
                  {rest.map((p) => (
                    <div key={`${p.email || p.name}-${p.rank}`} className="flex items-center justify-between p-4 md:p-5 border-b border-black/10 last:border-b-0 hover:bg-[#FFF4E6]/50 transition-colors">
                      <div className="flex items-center gap-4">
                        <div className="w-10 h-10 rounded-full bg-[#1a1a1a] text-[#FFF4E6] flex items-center justify-center font-display">#{p.rank}</div>
                        <div>
                          <div className="font-brico font-bold">{p.name}</div>
                          <div className="text-xs uppercase opacity-60">{p.city}</div>
                        </div>
                      </div>
                      <div className="font-display text-2xl">{p.score.toLocaleString()}</div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          <div className="mt-10 text-center">
            <Link to="/play" className="btn-chunky primary"><Gamepad2 size={18} /> Beat the score</Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Leaderboard;
